import {
  datagridStore,
  datagridFilterStore,
  datagridHistoryStore,
} from "../../../stores/datagrid.store";

import { hooksStore } from "../../../stores/hooks.store";

import { get as get_store } from "svelte/store";
import get from "get-value";
import set from "set-value";
import isNumber from "lodash/isNumber";
import defaultsDeep from "lodash/defaultsDeep";
import { Base64 } from "js-base64";
import prntr from "prntr";

import {
  vratDatagridData,
  vratDatagridDataDownload,
  vratExportLv,
} from "../../../api/datagrid";
import { zobrazDataNaMape } from "../../../helpers/map";

hooksStore.addAction("nacitajDatagrid", "datagrid.func.js", nacitajDatagrid);
hooksStore.addFilter(
  "resetniANastavFilter",
  "datagrid.func.js",
  resetniANastavFilter
);

function resetniANastavFilter(data) {
  data = defaultsDeep(data, {
    id: "",
    tab: "default",
    pagination: {
      start: 0,
    },
    order: {
      column: "0",
      type: "asc",
    },
    search: "",
    layer: "",
    outputType: "",
  });
  return data;
}

/**
 * Nacitanie datagridu pre polozku z datagridu
 * @param {object} data
 */
export async function tableItemLinkClick(data) {
  // hodnotu destiination treba rozdelit podla lomitka
  // aby sme ziskali type a tab
  const dest = get(data, "destination");
  let type, tab;
  if (dest) {
    [type, tab] = dest.split("/");
  }
  // ak je tab "default", tak zatial napevno nastavim "obyvatelia"
  // inak by to api nezobralo
  // tab = tab === "default" ? "" : tab;

  // nastavim GET premenne z dat a resetnem strankovanie
  upravFilter({
    id: get(data, "id", 0),
    type: type,
    tab: tab,
    pagination: {
      start: 0,
    },
    order: {
      column: "0",
      type: "asc",
    },
    search: "",
    layer: "",
  });

  // ziskam data z API
  await ziskajData();

  hooksStore.doAction("zobrazDatagrid");
}

/**
 * Nacitanie datagridu z prepinania tabov
 * @param {object} data
 */
export async function tableHeaderTabClick(data) {
  // resetnem zoradovanie a strankovanie
  data.order = { column: "0", type: "asc" };
  data.pagination = { start: 0 };
  data.search = "";
  // upravim data filtra
  upravFilter(data);
  // ziskam data z API
  await ziskajData();

  hooksStore.doAction("zobrazDatagrid");
}

/**
 * Ziskanie dat z API
 * @param {object} data
 */
export async function ziskajData(data = false) {
  hooksStore.doAction("zobrazDatagridTabulku", false);
  // nacitanie dat filtra
  const filter = get_store(datagridFilterStore);
  // ak nie su zadane data, tak ich nacitavam z API
  // ak zadane su, jedna sa o kompletne data z historie
  if (!data) {
    data = await vratDatagridData(filter);
    // ulozenie dat do historie
    historyAdd(data);
  }

  if (data) {
    // ulozenie dat do pamate
    datagridStore.set(data);
  }

  // upravenie dat filtra, nakolko tieto data sa nemusia zhotovat so zadanymi a vratenymi
  // napr. neposlem tab, ale api mi tab vrati
  upravFilter(data);
}

/**
 * Ziskanie export dat z API
 * Ponukne rovno subor na stiahnutie
 * @param {object} data
 */
export async function ziskajLvExport(nazov) {
  // nacitanie dat filtra
  const filter = get_store(datagridFilterStore);
  filter.post.outputType = "lv";
  filter.post.pagination.limit = 999;
  const fileName = `${nazov}-${new Date()
    .toISOString()
    .slice(0, 10)}-${Math.floor(Date.now() / 1000)}.pdf`;
  await vratExportLv(filter, fileName);
}

/**
 * Ziskanie export dat z API
 * Ponukne rovno subor na stiahnutie
 * @param {object} data
 */
export async function ziskajExportDat(fileType = "csv") {
  // nacitanie dat filtra
  const filter = get_store(datagridFilterStore);
  filter.post.outputType = fileType;
  filter.post.pagination.limit = 999;
  const fileName = `${filter.get.tab}-${filter.get.tab}-${new Date()
    .toISOString()
    .slice(0, 10)}-${Math.floor(Date.now() / 1000)}.${fileType}`;
  await vratDatagridDataDownload(filter, fileName);
}

/**
 * Prehliadacu da rovno moznost tlace z JSON dat
 */
export async function tlacTabulku() {
  const filter = get_store(datagridFilterStore);
  filter.post.pagination.start = 0;
  filter.post.pagination.limit = 999;

  const data = await vratDatagridData(filter);

  const columns = data.columnNames.map((s) => {
    s.field = s.columnId;
    s.displayName = s.name;
    s.columnSize = "auto";
    return s;
  });
  let header = [];
  data.header.forEach((element) => {
    header.push(element.nazov);
  });

  prntr({
    printable: data.data,
    properties: columns,
    type: "json",
    header: `<h3 style="display: inline-block; width: 80%;">${header.join(
      " "
    )}</h3><img style="float: right; margin: 13px 0; height: 30px; vertical-align: middle;" src="/assets/img/smartmap-color.svg" />`,
    gridStyle: "border: 1px solid #eeeeee; padding: 2px 5px;",
    gridHeaderStyle:
      "border: 1px solid #eeeeee; text-align: left; padding: 2px 5px; width: auto;",
    style: "table: table-layout: auto; width: 100%; ",
    scanStyles: false,
  });
}

/**
 * Uprava dat filtra.
 * Spaja posielane data s tymi,m co su uz ulozene
 * @param {object} data
 */
function upravFilter(data) {
  let decodedLayer;
  if (data && data.layer !== undefined && data.layer) {
    if (Base64.isValid(get(data, "layer"))) {
      decodedLayer = JSON.parse(Base64.decode(get(data, "layer").toString()));
    } else {
      decodedLayer = get(data, "layer");
    }
  }
  const filter = get_store(datagridFilterStore);
  const newFilter = {
    get: {
      id: get(data, "id[0]") || get(data, "id", "") || filter.get.id,
      type: get(data, "type") || filter.get.type,
      tab:
        data && data.tab !== undefined
          ? get(data, "tab", "default")
          : filter.get.tab,
    },
    post: {
      search:
        data && data.search !== undefined
          ? get(data, "search", "")
          : filter.post.search,
      layer:
        data && data.layer !== undefined
          ? data.layer
            ? decodedLayer
            : ""
          : filter.post.layer,
      pagination: {
        start: isNumber(get(data, "pagination.start"))
          ? get(data, "pagination.start")
          : filter.post.pagination.start,
        limit: get(data, "pagination.limit") || filter.post.pagination.limit,
      },
      order: {
        column: parseInt(
          data && data.order && data.order.column !== undefined
            ? get(data, "order.column", 0)
            : filter.post.order.column
        ),
        type: get(data, "order.type") || filter.post.order.type,
      },
      outputType:
        data && data.outputType !== undefined
          ? get(data, "outputType", "")
          : filter.post.outputType || null,
    },
  };
  datagridFilterStore.set(newFilter);
}

/**
 * Zoradovanie dat v tabulke
 * @param {object} data
 */
export async function order(data) {
  // nacitanie dat filtra
  const filter = get_store(datagridFilterStore);
  // defaultna hodnota zoradenia
  data.order.type = "asc";
  // ak je zoradovany stlpec rovanky, cize bolo druhy krat kliknute na stlpec
  // cize prisla poziadavka na zmenu asc/desc
  if (filter.post.order.column === data.order.column) {
    // vymena zoradenia
    if (filter.post.order.type === "asc") {
      data.order.type = "desc";
    }
  }
  set(data, "pagination.start", 0);
  // uprava dat filtra
  upravFilter(data);
  // nacitanie dat z api
  await ziskajData();
  hooksStore.doAction("zobrazDatagrid");
}

/**
 * Pridanie dat do historie prehliadania tabulky
 * @param {object} data
 */
function historyAdd(data) {
  const historyStore = get_store(datagridHistoryStore);
  // ak som sa vratil v historii dozadu a klikol som na novu polozku co chcem nacitat
  // tak od toho momentu historie vsetko ostatne zmazem
  if (
    historyStore.data.length &&
    historyStore.active != historyStore.data.length - 1
  ) {
    historyStore.data.splice(historyStore.active + 1);
  }
  // maximalny pocet krokov historie
  if (historyStore.data.length >= 50) {
    historyStore.data.shift();
  }
  // pridanie novych dat do historie
  historyStore.data.push(data);
  // uprava aktivneho indexu historie
  historyStore.active = historyStore.data.length - 1;
  // ulozenie dat historie
  datagridHistoryStore.set(historyStore);
}

/**
 * Vratenie sa spat v historii prehliadania tabulky
 */
export async function historyBack() {
  const historyStore = get_store(datagridHistoryStore);
  // index predchadzajucich dat
  const index = historyStore.active - 1;
  // ak existuje predchadzajuci krok
  if (index >= 0) {
    historyStore.active = index;
    // ulozenie aktualizovanej hodnoty aktivneho kroku
    datagridHistoryStore.set(historyStore);
    // uprava dat filtra
    upravFilter(historyStore.data[index]);
    // zobrazenie dat historie
    // nenacitava sa z API
    await ziskajData(historyStore.data[index]);
    hooksStore.doAction("zobrazDatagrid");
  }
}

/**
 * Posun vpred v hisotrii prehliadania tabulky
 */
export async function historyForward() {
  const historyStore = get_store(datagridHistoryStore);
  // index nasledujuceho kroku historie
  const index = historyStore.active + 1;
  // ak nasledujuci krok existuje
  if (index < historyStore.data.length) {
    historyStore.active = index;
    // ulozenie aktualizovanej hodnoty aktivneho kroku
    datagridHistoryStore.set(historyStore);
    // uprava dat filtra
    upravFilter(historyStore.data[index]);
    // zobrazenie dat historie
    // nenacitava sa z API
    await ziskajData(historyStore.data[index]);
    hooksStore.doAction("zobrazDatagrid");
  }
}

/**
 * Vyhladavanie podla textu
 * @param {string} search
 */
export async function search(search) {
  // nastavim GET premenne z dat
  // a resetnem strankovanie a zoradovanie
  upravFilter({
    search: search,
    pagination: {
      start: 0,
    },
    order: {
      column: "0",
      type: "asc",
    },
  });

  // ziskam data z API
  await ziskajData();
  hooksStore.doAction("zobrazDatagrid");
}

export async function paginate(page) {
  // nastavim GET premenne z dat
  upravFilter({
    pagination: {
      start: page,
    },
  });

  // ziskam data z API
  await ziskajData();
  hooksStore.doAction("zobrazDatagrid");
}

async function nacitajDatagrid(data) {
  upravFilter(data);
  await ziskajData();
  hooksStore.doAction("zobrazDatagrid");
}

export async function tableHeaderBreadcrumbsClick(data) {
  zobrazDataNaMape(data);
  await nacitajDatagrid(data);
}
